import { apiClient } from './authService';

const userService = {
  // Admin endpoints
  getAllUsers: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/admin/users/?${queryParams}` : '/admin/users/';
    const response = await apiClient.get(url);
    return response.data;
  },

  getResponsables: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/admin/bu_coordinators/?${queryParams}` : '/admin/bu_coordinators/';
    const response = await apiClient.get(url);
    return response.data;
  },

  getTrainers: async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `/responsable/trainers/?${queryParams}` : '/responsable/trainers/';
    const response = await apiClient.get(url);
    return response.data;
  },

  createUser: async (data) => {
    const response = await apiClient.post('/admin/create_user/', data);
    return response.data;
  },

  updateUser: async (id, data) => {
    const response = await apiClient.put(`/admin/${id}/update_user/`, data);
    return response.data;
  },

  updateNotificationPreferences: async (id, preferences) => {
    const response = await apiClient.patch(`/admin/${id}/notification_preferences/`, preferences);
    return response.data;
  },

  assignCentresToResponsable: async (responsableId, centreIds = []) => {
    const response = await apiClient.post(`/admin/${responsableId}/assign_centres/`, {
      centre_ids: centreIds,
    });
    return response.data;
  },

  // Common endpoints
  getCentres: async () => {
    const response = await apiClient.get('/centres/');
    return response.data;
  },

  getFournisseurs: async () => {
    const response = await apiClient.get('/fournisseurs/');
    return response.data;
  },

  // Delete endpoints
  deleteUser: async (id) => {
    const response = await apiClient.delete(`/admin/${id}/delete_user/`);
    return response.data;
  },

  reactivateUser: async (id) => {
    const response = await apiClient.post(`/admin/${id}/reactivate_user/`);
    return response.data;
  },

  // Email endpoints
  sendCredentialsEmail: async (id) => {
    const response = await apiClient.post(`/admin/${id}/send_credentials/`);
    return response.data;
  },

  sendPasswordResetEmail: async (id) => {
    const response = await apiClient.post(`/admin/${id}/send_password_reset/`);
    return response.data;
  },
};

export default userService;
